import * as React from "react";
import { connect } from "react-redux";
import { Theme, createStyles } from '@mui/material/styles';;
import { withStyles, WithStyles } from '@mui/styles';;
import idssStyle from "../../../Configuration/SharedStyling";
import {
    IGenericUserProps,
    genericMapStateToProps
} from "../../../DataClasses/GenericUser";
import { Redirect } from "react-router-dom";
import { Grid2 as Grid } from "@mui/material";
import BackNavigation from "../../Shared/BackNavigation";
import { ISubmissionAccredStatus } from "../../../DataClasses/ReportData";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import ReportsService from "../../Services/ReportsService";
import SharedMaterialReactTable, { ISharedTableColumn } from "../../Shared/MaterialReactTable";

const styles = (theme: Theme) => createStyles({ ...idssStyle(theme) });

interface IAccreditationStatusReportState {
    data: any[];
    isLoading: boolean;
    redirect: boolean;
}

type IStylesProps = WithStyles<typeof styles>;

// VIEW
class AccreditationStatusReportView extends React.Component<
    IGenericUserProps & IStylesProps,
    IAccreditationStatusReportState
> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: [],
            isLoading: true,
            redirect: false
        };
    }

    public componentDidMount() {
        this.RefreshModel();
    }

    public render() {
        if (this.state.redirect) {
            return <Redirect to="/error" />;
        }
        const { classes } = this.props;

        // Column definitions for SharedMaterialReactTable
        const getAccreditationStatusColumns = (): ISharedTableColumn<any>[] => [
            {
                accessorKey: 'orgId' as any,
                header: 'Org ID',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'subId' as any,
                header: 'Sub ID',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'orgName' as any,
                header: 'Org Name',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'productLine' as any,
                header: 'Product Line',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'reportingProduct' as any,
                header: 'Reporting Product',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'accredStatus' as any,
                header: 'Accred Status',
                enableSorting: true,
                enableFiltering: true,
            },
        ];

        return (
            <Grid container={true} className={classes.gridRowFlex} spacing={0}>
                <Grid size={12}>
                    <Grid container={true} spacing={2}>
                        <Grid size={12}>
                            <BackNavigation text="Back to Reports" href="/reportspage" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <div className={classes.card}>
                        <SharedMaterialReactTable
                            data={this.state.data}
                            columns={getAccreditationStatusColumns()}
                            title="Accreditation Status Report"
                            isLoading={this.state.isLoading}
                            enablePagination={true}
                            enableSorting={true}
                            enableFiltering={true}
                            enableColumnActions={true}
                            enableRowActions={false}
                            initialState={{
                                pagination: { pageIndex: 0, pageSize: 20 },
                            }}
                            muiPaginationProps={{
                                rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                            }}
                            emptyMessage="No data found."
                        />
                    </div>
                </Grid>
            </Grid>
        )
    }

    private async RefreshModel() {
        this.setState({ isLoading: true });
        const retval: ISubmissionAccredStatus[] | AjaxError = await firstValueFrom(
            ReportsService.GetSubmissionsAccredStatus$(this.props.user)
        );
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        } else {
            this.setState({
                data: retval.map(item => ({
                    orgId: item.organizationId,
                    subId: item.submissionId,
                    orgName: item.orgName,
                    productLine: item.productLine,
                    reportingProduct: item.reportingProduct,
                    accredStatus: item.isAccredited === true ? "Accredited" : "Not Accredited"
                }))
            });
        }
        this.setState({ isLoading: false });
    }
    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }
    private setRedirectState() {
        this.setState({ redirect: true });
    }
}

// REDUX CONTAINER
const AccreditationStatusReportPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(AccreditationStatusReportView);

// STYLES CONTAINER
const AccreditationStatusReportPage = withStyles(styles)(
    AccreditationStatusReportPageWithState
);

export default AccreditationStatusReportPage;
